export default __webpack_public_path__ + "static/media/recruiter-bot-bg.eb95102c.svg";